import { useState } from 'react'
import { useI18n } from '../i18n'
import { Banner, SupportCard } from '../components/bits'
import { ShareBox } from '../components/ShareBox'
import { setPost } from '../lib/journal'
import { useSession } from '../store/session'

export function FreeResult() {
  const { t } = useI18n()
  const s = useSession()
  const [post, setPostText] = useState(s.postDraft)
  const [saved, setSaved] = useState(false)

  const savePost = () => {
    s.set({ postDraft: post })
    if (s.entryId) setPost(s.entryId, post)
    setSaved(true)
    setTimeout(() => setSaved(false), 2000)
  }

  return (
    <section className="screen">
      <h2>{t.fresult.title}</h2>
      {s.aiFailed && <Banner text={t.errors.aiFallback} />}
      <div className="solo">
        <img src={s.beforePNG ?? ''} alt="" />
      </div>
      <div className="card">
        <h3>{t.fresult.responseCard}</h3>
        <p>{s.freeText}</p>
        <span className="state-pill">{t.result.statePrefix}{s.freeState}</span>
      </div>

      {s.support && <SupportCard />}

      <div className="card">
        <h3>{t.result.postCard}</h3>
        <textarea
          className="feel"
          placeholder={t.fresult.postPlaceholder}
          value={post}
          onChange={(e) => setPostText(e.target.value)}
        />
        <div className="btn-row" style={{ marginTop: 10 }}>
          <button className="btn btn-ghost" style={{ padding: 11 }} onClick={savePost}>
            {t.result.savePost}
          </button>
        </div>
        {saved && <p className="muted" style={{ fontSize: 13, marginTop: 8 }}>{t.result.postSaved}</p>}
      </div>

      <ShareBox img={s.beforePNG!} state={s.freeState} />

      <div className="btn-row col">
        <button className="btn btn-ghost" onClick={() => s.go('draw')}>
          {t.fresult.continue}
        </button>
        <button
          className="btn btn-ghost"
          onClick={() => {
            s.set({ strokes: [], exStrokes: [], beforePNG: null, afterPNG: null, entryId: null, postDraft: '', mode: 'free' })
            s.go('draw')
          }}
        >
          {t.fresult.newDrawing}
        </button>
      </div>
    </section>
  )
}
